"use client";

import styled from "styled-components";

interface TextColor {
  $color: "red" | "green" | "blue";
}
interface ValueColor {
  $colorValue: "red" | "green" | "yellow" | "blue" | "colorTitle" | undefined;
}

export const BoxCard = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 10px;
  background: var(--backgroundColorCard);
  padding: 25px;
  border-radius: 0.5rem;
  box-shadow: 0 0 6px -5px var(--shadow);
`;

export const Title = styled.h4`
  font-family: "Inter Medium";
  font-size: 14px;
  color: var(--textLight);
  margin-bottom: 0;
`;

export const Value = styled.h2<ValueColor>`
  font-family: "Inter Medium";
  font-size: 25px;
  color: ${({ $colorValue }) =>
    $colorValue === "red"
      ? `var(--red)`
      : $colorValue === "yellow"
        ? `var(--yellow)`
        : $colorValue === "green"
          ? `var(--green)`
          : $colorValue === "blue"
            ? `var(--blue)`
            : `var(--colorTitle)`};
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0;
  line-height: 30px;
`;

export const TextColor = styled.span<TextColor>`
  font-weight: 400;
  font-size: 13px;
  color: ${({ $color }) =>
    $color == "red"
      ? `var(--red)`
      : $color == "blue"
        ? `var(--blue)`
        : `var(--green)`};
  display: block;
  height: fit-content;
`;

export const HeaderCard = styled.div`
  display: flex;
  algin-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ListSmall = styled.ul`
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

export const ItemList = styled.ul`
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;

  ${Value} {
    font-size: 18px;
  }
`;
